import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogoDeExclusao',
  props: {
    value: { type: Boolean },
    nome: null,
    onExcluir: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean,
  nome: string,
  onExcluir?: () => unknown | Promise<unknown>,
};





const model = computed<boolean>({
  get: () => props.value,
  set: (v) => emit('input', v),
})

const excluindo = ref(false)

async function handleExclusao() {
	excluindo.value = true

	try {
		if (props.onExcluir) {
			await props.onExcluir()
		}
		model.value = false
	} finally {
		excluindo.value = false
	}
}

return { __sfc: true,props, emit, model, excluindo, handleExclusao }
}

})